import React, { useState, useEffect } from "react";
import { FaStar, FaQuoteLeft, FaChevronLeft, FaChevronRight } from "react-icons/fa";

const reviews = [
  {
    name: "Jenny Mathews",
    role: "Operations Manager",
    text: "This platform changed how we track all our equipment. The warranty alerts alone saved us from many missed claims. The dashboard gives us instant visibility.",
    stars: 5
  },
  {
    name: "Jason Turner",
    role: "IT Team Lead",
    text: "Managing hundreds of devices used to be a headache. Now our entire inventory is tracked with warranty and lifecycle details in one place.",
    stars: 5
  },
  {
    name: "David Nguyen",
    role: "Maintenance Supervisor",
    text: "The maintenance scheduling feature is a game-changer. We've reduced unexpected breakdowns significantly since we started using this.",
    stars: 5
  },
  {
    name: "James Lee",
    role: "Facilities Coordinator",
    text: "Tracking equipment inspections and compliance was always complicated. This platform automates it all — scheduling, alerts, and records.",
    stars: 4
  },
  {
    name: "Sara Kim",
    role: "Warehouse Manager",
    text: "All our assets are now fully tracked. The skill-based assignment feature ensures the right person handles each maintenance task.",
    stars: 5
  },
  {
    name: "Emily Davis",
    role: "Field Technician",
    text: "As a technician, I love the task management. I can see all my assignments, update progress, and the checklist feature ensures nothing gets missed.",
    stars: 4
  }
];

const ReviewSection = () => {
  const [current, setCurrent] = useState(0);
  const [perPage, setPerPage] = useState(3);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 640) setPerPage(1);
      else if (window.innerWidth < 1024) setPerPage(2);
      else setPerPage(3);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const maxPage = Math.ceil(reviews.length / perPage) - 1;

  const prev = () => setCurrent((c) => (c > 0 ? c - 1 : maxPage));
  const next = () => setCurrent((c) => (c < maxPage ? c + 1 : 0));

  const visible = reviews.slice(current * perPage, current * perPage + perPage);

  return (
    <section id="reviews" className="lp-reviews">
      <div className="lp-reviews__inner">
        <div className="lp-section-header">
          <span className="lp-section-tag">Testimonials</span>
          <h2>Trusted by Teams Everywhere</h2>
          <p>Hear from people who use this platform to manage their assets every day.</p>
        </div>

        <div className="lp-reviews__carousel">
          <button className="lp-reviews__arrow" onClick={prev}><FaChevronLeft /></button>

          <div className="lp-reviews__cards">
            {visible.map((r, i) => (
              <div className="lp-reviews__card" key={i}>
                <FaQuoteLeft className="lp-reviews__quote" />
                <p className="lp-reviews__text">{r.text}</p>
                <div className="lp-reviews__stars">
                  {Array.from({ length: 5 }).map((_, idx) => (
                    <FaStar key={idx} className={idx < r.stars ? "filled" : "empty"} />
                  ))}
                </div>
                <div className="lp-reviews__author">
                  <div className="lp-reviews__avatar">
                    {r.name.split(" ").map((n) => n[0]).join("")}
                  </div>
                  <div>
                    <strong>{r.name}</strong>
                    <span>{r.role}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <button className="lp-reviews__arrow" onClick={next}><FaChevronRight /></button>
        </div>

        <div className="lp-reviews__dots">
          {Array.from({ length: maxPage + 1 }).map((_, idx) => (
            <button
              key={idx}
              className={`lp-reviews__dot ${idx === current ? "active" : ""}`}
              onClick={() => setCurrent(idx)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ReviewSection;
